import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function HeroSection() {
  const { t, i18n } = useTranslation()

  return (
    <section className="relative w-full min-h-[calc(100vh-40px)] flex flex-col justify-center pt-0 pb-12 md:pt-0 md:pb-20 overflow-hidden">
      {/* Abstract Background Element */}
      <div className="absolute top-[-20%] left-[-10%] w-[60%] h-[80%] bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="w-full h-full flex items-center justify-center px-4">
        <div className="relative max-w-[1000px] w-full flex flex-col md:flex-row items-center justify-center mt-10 md:mt-16">
          <div className={`contents md:flex md:flex-col md:items-center animate-slide-up w-full md:w-[50%] z-10 ${i18n.language === 'es' ? 'md:translate-x-2' : 'md:translate-x-6'}`} style={{ animationDelay: '0.1s' }}>
            <div className="order-1 md:order-none relative mb-6 md:mb-8 w-full max-w-[480px] flex flex-col items-center">
              <p className="font-sans text-base md:text-base tracking-[0.1em] text-hero-subtext opacity-80 mb-2">
                {t('hero.date')}
              </p>
              <img
                src={i18n.language === 'es' ? "/images/text/nos_vamos_de_boda.svg" : "/images/text/were_getting_married.svg"}
                alt={t('hero.line1') + ' ' + t('hero.line2')}
                className="w-full h-auto object-contain scale-[0.9] md:scale-[1.0] origin-center mt-3 md:mt-5"
              />
            </div>

            <p className="order-3 md:order-none font-sans text-base md:text-base tracking-[0.1em] text-hero-subtext opacity-80 leading-[1.6] max-w-[380px] text-center mb-6 whitespace-pre-line z-10">
              {t('hero.subtext')}
            </p>

            <div className="order-4 md:order-none flex justify-center w-full">
              <Link to="/rsvp" className="font-display text-[28px] md:text-[36px] text-[#93652B] tracking-[0.3em] hover:text-[#A89461] transition-colors uppercase leading-none z-10">
                {t('nav.rsvp')}
              </Link>
            </div>
          </div>

          <div className={`order-2 md:order-none relative flex justify-center md:justify-start w-full md:w-[50%] ${i18n.language === 'es' ? 'md:-translate-x-4' : 'md:-translate-x-10'} pointer-events-none`}>
            <img
              src="/images/hero.svg"
              alt="Wedding celebration"
              className="relative w-[60%] md:w-[80%] lg:w-[100%] max-w-none h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
